import React from 'react'
import classes from "./TabsContainer.module.css"
const TabsContainer = ({Tag="menu",children,tabs}) => {
  return (
    <Tag className={classes.tabsContainer}>     
    <div className={classes.menuWrapper}>
    {tabs}
    {children}
    </div>
    </Tag>
  )
}

export default TabsContainer